import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Poolcorp Custom Code
import React, { FC } from "react";
// import { connect } from "react-redux"; // Poolcorp Custom Code
import { css } from "styled-components";

/* Poolcorp Custom Code */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Hidden from "@insite/mobius/Hidden";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Filters from "@store/Components/Icons/Filters";
import setIsFilterNavOpen from "@store/Store/Pages/ProductList/Handlers/SetIsFilterNavOpen";
import { linkStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import getWidgetComponent from "@store/utilities/getWidgetComponent";
import { connect, ResolveThunks } from "react-redux";

const ProductCount = getWidgetComponent("ProductList/ProductListProductCount");
const SortSelect = getWidgetComponent("ProductList/ProductListSortSelect");
const ProductListSuggestion = getWidgetComponent("ProductList/ProductListSuggestion");
/* Poolcorp Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    view: state.pages.productList.view,
});

/* Poolcorp Custom Code */
const mapDispatchToProps = {
    setIsFilterNavOpen,
};
/* Poolcorp Custom Code */

type Props = ReturnType<typeof mapStateToProps> & WidgetProps & ResolveThunks<typeof mapDispatchToProps>; // Poolcorp Custom Code

export interface ProductListControlsContainerStyles {
    container?: GridContainerProps;
    countGridItem?: GridItemProps;
    countTableViewGridItem?: GridItemProps;
    sortGridItem?: GridItemProps;
    sortTableViewGridItem?: GridItemProps;
    filterGridItem?: GridItemProps;
    filterTableViewGridItem?: GridItemProps;
    viewSelectGridItem?: GridItemProps;
    viewSelectTableViewGridItem?: GridItemProps;
    // Poolcorp Custom Code
    wrapper?: InjectableCss;
    item?: InjectableCss;
    itemRight?: InjectableCss;
    openModalLink?: LinkPresentationProps;
}

export const controlsContainerStyles: ProductListControlsContainerStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-flow: wrap;
            justify-content: space-between;
            align-items: center;
            text-align: center;
            margin: -0.25em -0.5em;
        `,
    },
    item: {
        css: css`
            padding: 0.25em 0.5em;
        `,
    },
    itemRight: {
        css: css`
            padding: 0.25em 0.5em;
            @media print {
                display: none;
            }
        `,
    },
    openModalLink: {
        typographyProps: {
            weight: TYPOGRAPHY.weight.black,
        },
        icon: {
            iconProps: {
                src: Filters,
                size: 20,
                color: "inherit",
            },
            position: "right",
        },
        css: css`
            ${linkStyles()}
            ${props =>
                breakpointValuesMediaQueries(
                    props.theme,
                    [{ values: ["inline-flex", null, "none"], properties: ["display"] }],
                    mediaOptions.min,
                )}
        `,
    },
};

const styles = controlsContainerStyles;

const ProductListControlsContainer: FC<Props> = ({ 
    id, 
    view,
    // Poolcorp Custom Code
    setIsFilterNavOpen,
}) => {
    /* Poolcorp Custom Code */
    const openModal = () => {
        setIsFilterNavOpen({ isOpen: true });
    };

    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <StyledWrapper {...styles.item}>
                    <ProductCount />
                    <ProductListSuggestion />
                </StyledWrapper>
                <StyledWrapper {...styles.itemRight}>
                    <Link {...styles.openModalLink} onClick={openModal}>
                        {translate("Sort & Filter")}
                    </Link>
                    <Hidden below="md">
                        <SortSelect />
                    </Hidden>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
    /* Poolcorp Custom Code */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
